module.exports = __webpack_public_path__ + "static/media/icon-ervc.adf944bb.svg";